import axios from 'axios';
import { setTaxiEndpoint } from '../GetReservation';
import { TemporaryReservationParams } from './TemporaryReservationParams';

interface ApiConfig {
  baseURL: string;
  timeout: number;
}

const DEFAULT_API_CONFIG: ApiConfig = {
  baseURL: process.env['REACT_APP_API_ENDPOINT'] as string,
  timeout: 60000,
};

/** 仮予約APIを呼び出す。 */
export async function submitTemporaryReservation(params: TemporaryReservationParams) {
  try {
    const config = {
      ...DEFAULT_API_CONFIG,
    };
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    /** axiosのインスタンス。 */
    const instance = axios.create(config);
    /** 仮予約APIのパス。 */
    const path = await setPath();
    // 仮予約APIにPOSTメソッドでリクエストする。
    return await instance.post(path, {...params});
  } catch (err) {
    // エラーが発生した場合、nullを返す。
    return null;
  }
}

/** 環境に応じて呼び出すAPIのパスを切り替える。 */
async function setPath() {
  return setTaxiEndpoint('submit-temporary-reservation');
}
